'use client';

import Link from 'next/link';
import { Github, Linkedin, Twitter } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import LogoSvg from '@/components/LogoSvg';

export default function Footer() {
  const { t, setLanguage, language } = useLanguage();

  const socialLinks = [
    { Icon: Twitter, label: 'Twitter', href: '#' },
    { Icon: Linkedin, label: 'LinkedIn', href: '#' },
    { Icon: Github, label: 'GitHub', href: '#' },
  ];

  return (
    <footer className="bg-black border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-2">
            <Link href="/" className="flex items-center gap-2 mb-6">
              <LogoSvg className="w-auto h-6 opacity-90 hover:opacity-100 transition-opacity" />
            </Link>
            <p className="text-gray-300 max-w-sm mb-6 font-light">
              {t('footer.desc')}
            </p>
            <div className="flex gap-4 mb-6">
              {socialLinks.map(({ Icon, label, href }, i) => (
                <a
                  key={i}
                  href={href}
                  aria-label={label}
                  className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-300 hover:bg-[#006546] hover:text-white transition-all"
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>

            {/* Language Switcher */}
            <div className="flex gap-4">
              <button
                onClick={() => setLanguage('pt')}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-full border transition-all ${language === 'pt' ? 'border-[#19ffb5] bg-[#006546]/20 text-white' : 'border-white/10 text-gray-300 hover:border-white/30'}`}
              >
                <span className="text-lg">🇧🇷</span>
                <span className="text-sm font-medium">Português</span>
              </button>
              <button
                onClick={() => setLanguage('en')}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-full border transition-all ${language === 'en' ? 'border-[#19ffb5] bg-[#006546]/20 text-white' : 'border-white/10 text-gray-300 hover:border-white/30'}`}
              >
                <span className="text-lg">🇺🇸</span>
                <span className="text-sm font-medium">English</span>
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">{t('footer.services')}</h3>
            <ul className="space-y-4 text-sm text-gray-300 font-light">
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.web')}</a></li>
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.seo')}</a></li>
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.ads')}</a></li>
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.ui')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">{t('footer.company')}</h3>
            <ul className="space-y-4 text-sm text-gray-300 font-light">
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.about')}</a></li>
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.case')}</a></li>
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.careers')}</a></li>
              <li><a href="#" className="hover:text-[#19ffb5] transition-colors">{t('footer.links.contact')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400 font-light">
          <p>{t('footer.rights')}</p>
          <div className="flex gap-8">
            <Link href="/politica-de-privacidade" className="hover:text-white transition-colors">{t('footer.privacy')}</Link>
            <Link href="/termos-de-uso" className="hover:text-white transition-colors">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
